
const initState = {
    serverTime: '',
    timeZone: '',
};

export type INITSTATE = {
  serverTime: string,
  timeZone:string
}

export type ServerTimeInfo = {
  serverTime: string,
  timeZone: string;
}

export type ACTION = {
  type: string
  value: ServerTimeInfo
}

export const SET_DEFAULT_TIME = 'set_default_time';


export const defaultTime = (state: INITSTATE = initState, action: ACTION) => {
    switch (action.type) {
        case SET_DEFAULT_TIME:
            return {...state, serverTime: action.value.serverTime, timeZone: action.value.timeZone ? action.value.timeZone : state.timeZone };
        default:
            return state;
    }
};
